import Vue from 'vue'
import App from './App.vue'
import VueScrollTo from 'vue-scrollto'
import Buefy from 'buefy'
import './assets/scss/app.scss'
import VueAnalytics from 'vue-analytics'
import VueLazyload from 'vue-lazyload'

Vue.use(VueAnalytics, {
  checkDuplicatedScript: true,
  id: 'UA-72135513-6'
})

Vue.use(Buefy)
Vue.use(VueScrollTo)
Vue.use(VueLazyload)

Vue.config.productionTip = false

Vue.filter('phone', function (phone) {
  return phone.replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
});


Vue.filter('phone2', {
  read: function (value) {
    return value
  },
  write: function (value) {
    return value.replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
})
new Vue({
  render: h => h(App)
}).$mount('#app')
